import React from 'react'
import { NavLink } from 'react-router-dom'
import HomePersonaSection from './HomePersonaSection'

export default function HomePersona() {
    return (
        <div>
            <div className='bg-mainColor  md:ml-[3.688rem] pt-[5.5rem] pl-[2rem] pr-[4.438rem] pb-[2.75rem]'>
                <HomePersonaSection />
                <div className='mt-5'>
                    <NavLink to='/' className="black-button">
                        More
                    </NavLink>
                </div>
            </div>
        </div>
    )
}
